"use strict";
var twentyninetimes = twentyninetimes || {};

const productsContainer = document.querySelector(".block-iphone__products");

twentyninetimes.iphone =
    twentyninetimes.iphone ||
    (function () {
        function init() {
            if (!productsContainer) return;

            const swiper = new Swiper(".swiper", {
                // Optional parameters
                direction: "vertical",
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                allowSlidePrev: true,
                allowSlideNext: true,
                allowTouchMove: true,
                grabCursor: true,
                // spaceBetween: 30,
            });


        }

        return {
            init: init,
        };
    })();